// extracted by mini-css-extract-plugin
var _1 = "PostInfo-modulePostInfo__j0aPh";
var _2 = "PostInfo-moduledate__L4dgF";
var _3 = "PostInfo-moduledivider__QNCbB Divider-moduleDivider__dL3Vg";
export { _1 as "PostInfo", _2 as "date", _3 as "divider" }
